import { DateInput } from "../../fields/date-input";

export function CellDateInput<T extends object>({
  model,
  attr,
  type,
  required,
}: {
  model: T;
  attr: keyof T;
  type: "datetime-local" | "date";
  required?: boolean;
}) {
  return (
    <DateInput attr={attr} model={model} type={type} required={required} />
  );
}
